import { Fade, Typography } from '@mui/material';
import React from 'react';

interface Props {
  message?: string;
  isVisible: boolean;
}

const FormError = ({ message, isVisible }: Props): JSX.Element => (
  <Fade in={isVisible} exit>
    <Typography
      sx={{
        color: (theme) => theme.palette.error.main,
      }}
    >
      {message}
    </Typography>
  </Fade>
);

export default FormError;
